import { lightTheme } from "../../../theme/theme";
type Theme = typeof lightTheme;

export const HeaderStyles = (theme: Theme) => ({
  header: {
    display: "flex",
    alignItems: "center",
    padding: "0.75rem 1rem",
    backgroundColor: theme.background,
    color: theme.text,
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 500,
    fontSize: 16,
  },
  logoWrap: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    flexShrink: 0,
    fontWeight: 700,
  },
  rightWrap: {
    marginInlineStart: "auto",
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  navList: {
    display: "flex",
    gap: "1.5rem",
    listStyle: "none",

    margin: 0,
    padding: 0,
    overflow: "visible", // just in case
  },
});
